// A liga da semana: com patrocinador cadastrado (tabela ligas), nome, marca e prêmio dele; sem, a liga padrão.
import { limitesDaSemana, semanaDe } from './tempo.ts';
import type { Liga } from './tipos.ts';

export const NOME_DA_LIGA_PADRAO = 'Liga da Semana Truco de 6';

// Uma linha da tabela ligas: o patrocínio vale de inicio a fim.
export interface LigaCadastrada {
  id: string;
  nome: string;
  marcaNome: string;
  marcaLogo: string | null; // URL da imagem do logo
  marcaCor: string | null; // cor da marca (#RRGGBB), usada no lugar do token sponsor-500
  premio: string | null;
  inicio: number;
  fim: number;
}

export function ligaDaSemana(cadastradas: readonly LigaCadastrada[], agora: number): Liga {
  const semana = semanaDe(agora), { inicio, fim } = limitesDaSemana(semana);
  const l = [...cadastradas].sort((a, b) => b.inicio - a.inicio).find((x) => x.inicio <= agora && agora <= x.fim);
  if (!l) return { id: 'padrao', nome: NOME_DA_LIGA_PADRAO, marca: null, premio: null, semana, inicio, fim };
  return { id: l.id, nome: l.nome, marca: { nome: l.marcaNome, logo: l.marcaLogo, cor: l.marcaCor }, premio: l.premio, semana, inicio, fim };
}
